<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgements">
<h1>Acknowledgements</h1>
<p>I’d like to thank Hugh and Carol Landon, who have always given me amazing parental support. My brothers, sister and whole family who have always been there for me.</p>
<p>Jody Katy Barry, who has always offered amazing friendship and gave me emotional and practical support through my school years.</p>
<p>All the staff at the Howard of Effingham School who made everything accessible for me.</p>
<p>Ros Reeve and Angela Baker, who were learning support assistants all through primary school.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?090b5b7a